import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../image/panorama/panorama-device.png'


const _withScopeId = n => (_pushScopeId("data-v-04deeb94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panorama" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panorama_bottom" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "panorama_deviceImg",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "panorama_container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "panorama_title" }, [
  /*#__PURE__*/_createTextVNode("林视界"),
  /*#__PURE__*/_createElementVNode("span", null, "：云观如身临")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "panorama_intro" }, "随时随地、在线浏览、随心而动、随意观看。", -1))

import { Viewer } from 'photo-sphere-viewer';
import { onMounted, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Panorama',
  setup(__props) {

const viewerContainer = ref()
// viewer.setOptions({
//   fisheye: true,
//   autorotateSpeed: '-1rpm',
// });
const viewer = ref();
onMounted(() => {
  viewer.value = new Viewer({
    container: viewerContainer.value,
    panorama: require('../image/panorama/panoramagram.jpg'),
    navbar: [],
    autorotateSpeed: 0.2,
    autorotateDelay: 5
  });
})
const handleLeave = () => {
  viewer.value.startAutorotate()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        class: "panorama_link",
        to: "/pancam"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6,
      _createElementVNode("div", {
        class: "panorama_viewer",
        ref_key: "viewerContainer",
        ref: viewerContainer,
        onMouseleave: handleLeave,
        onTouchend: handleLeave
      }, null, 544)
    ])
  ]))
}
}

})